const egnyteDomainRegExp = /^[a-z0-9]+\.egnyte\.com$/i;

const availableDomains = ['bob.qa-egnyte.com', 'egnyte.egnyte.com'];
module.exports = {
    isValidDomain(domain) {
        return egnyteDomainRegExp.test(domain);
    },
    isDomainEnabledForBehalfSuggestion(sessionDomain) {
        return availableDomains.includes(sessionDomain);
    },
};
